import { SET_YEARS } from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.years, action) {
  switch (action.type) {
    case SET_YEARS:
      return action.payload;
    case RESET_APP_STATE:
      return initialState.years;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/years/reducer.js